import React, { useEffect, useState } from 'react';

import { useBreakpoint } from 'gatsby-plugin-breakpoints';

import useEnableHecEmergencyBanner from '../../hooks/useEnableHecEmergencyBanner';
import {
  ClaimsAccordionContainer,
  ClaimsAccordionHeaderContainer,
  ClaimsAccordionHeaderTextContainer,
  MinusIcon,
  PlusIcon,
} from './ClaimsAccordion.style';

type Props = {
  header: React.ReactNode;
  content: React.ReactNode;
  handleOnClick: (index?: number) => void;
  index?: number;
  openIndex?: number;
  product?: string;
};

const ClaimsAccordion = ({
  header,
  content,
  handleOnClick,
  index,
  openIndex,
  product,
}: Props) => {
  const [expand, setExpand] = useState(false);
  const enableHecEmergencyBanner = useEnableHecEmergencyBanner();
  const isDesktop = useBreakpoint();
  const DESKTOP_HEADER_HEIGHT =
    enableHecEmergencyBanner && product === 'home' ? 160 : 80;

  useEffect(() => {
    if (index !== undefined && index === openIndex) {
      setExpand(true);
      setTimeout(() => {
        const target = document.querySelector(
          `#claims-section-${index}`
        ) as HTMLElement;
        window.scrollTo({
          top:
            target.getBoundingClientRect().top +
            window.scrollY -
            (isDesktop ? DESKTOP_HEADER_HEIGHT : 0),
          behavior: 'smooth',
        });
      }, 150);
    } else {
      setExpand(false);
    }
  }, [openIndex, index, isDesktop]);

  return (
    <ClaimsAccordionContainer
      id={`claims-section-${index}`}
      $isExpanded={expand}
      data-testid="claims-accordion"
    >
      <ClaimsAccordionHeaderContainer
        onClick={() => {
          handleOnClick(index);
        }}
        $isExpanded={expand}
      >
        <ClaimsAccordionHeaderTextContainer>
          {header}
        </ClaimsAccordionHeaderTextContainer>
        {expand ? (
          <MinusIcon data-testid="minus-icon" />
        ) : (
          <PlusIcon data-testid="plus-icon" />
        )}
      </ClaimsAccordionHeaderContainer>
      {expand && <>{content}</>}
    </ClaimsAccordionContainer>
  );
};
export default ClaimsAccordion;
